var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
export class Player extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.username = "";
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.rotation = 0;
        this.avatarData = "";
    }
}
__decorate([
    type("string")
], Player.prototype, "id", void 0);
__decorate([
    type("string")
], Player.prototype, "username", void 0);
__decorate([
    type("number")
], Player.prototype, "x", void 0);
__decorate([
    type("number")
], Player.prototype, "y", void 0);
__decorate([
    type("number")
], Player.prototype, "z", void 0);
__decorate([
    type("number")
], Player.prototype, "rotation", void 0);
__decorate([
    type("string")
], Player.prototype, "avatarData", void 0);
//# sourceMappingURL=Player.js.map